import React from "react";
import { Button } from "react-bootstrap";

export const ProfileEditButton = ({ onClick }) => {
  return (
    <Button
      variant="secondary btn-icon btn-icon-edit"
      size="sm"
      title="Edit"
      onClick={onClick}
    >
      <span className="bx bx-edit-alt"></span>
    </Button>
  );
};

export const ProfileSaveButton = ({ onClick }) => {
  return (
    <Button
      variant="success btn-icon btn-icon-save"
      size="sm"
      title="Save"
      onClick={onClick}
    >
      <span className="bx bx-check"></span>
    </Button>
  );
};

export const ProfileCancelButton = ({ onClick }) => {
  return (
    <Button
      variant="danger btn-icon btn-icon-cancel"
      size="sm"
      title="Cancel"
      onClick={onClick}
    >
      <span className="bx bx-x"></span>
    </Button>
  );
};

export const ProfileViewButton = ({ onClick }) => {
  return (
    <Button
      variant="success btn-icon-save head-btn view-profile-btn"
      size="sm"
      title="See Preview"
      onClick={onClick}
    >
      <div className="info-block">
        <div class="info-img">
        <span className="bx bx-show"></span>
        </div>
        <div className="info-tile text-start">
            <div className="info-heading"> View</div>
          <div className="text-muted">
           Your uploaded CV
          </div>
        </div>
      </div>
      
    </Button>
  );
};

export const ProfileReUploadButton = ({ onClick }) => {
  return (
    <Button
      variant="success btn-icon-save head-btn"
      size="sm"
      title="Re-Upload File"
      onClick={onClick}
    >
      <span className="bx bx-upload"></span> Upload CV
    </Button>
  );
};

export const ProfileAddImgButton = ({ onClick }) => {
  return (
    <Button
      variant="success btn-icon-save head-btn"
      size="sm"
      title="Add Profile Image"
      onClick={onClick}
    >
      <span className="bx bx-image-add"></span> Add Image
    </Button>
  );
};

export const ProfileViewImgButton = ({ onClick }) => {
  return (
    <Button
      variant="success btn-icon-save head-btn view-profile-btn"
      size="sm"
      title="See Preview"
      onClick={onClick}
    >
      {/* <span className="bx bx-show"></span> View Profile Image */}

      <div className="info-block">
        <div class="info-img">
        <span className="bx bx-show"></span>
        </div>
        <div className="info-tile text-start">
            <div className="info-tile"> 
            <div className="info-heading"> View</div>
            </div>
          <div className="text-muted">
           Your uploaded  Profile Image
          </div>
        </div>
      </div>
    </Button>
  );
};
